export const DOCUMENTS_DATE_FORMAT = 'MM/dd/yyyy';
